<div
  class="map"
  [id]="containerId"
  [ngClass]="{
    'drag-pan-disabled': disableDragPan,
    'has-location-permission': (hasLocationPermission$ | async),
  }"
>
  <div class="map-drawer-container">
    @if (enableMapControls) {
      <rdx-map-drawer [hasViewCurrentRidePermission]="(hasViewCurrentRidePermission$ | async) ?? false" />
    }
  </div>

  <rdx-search-this-area-button />

  @if (enableMapTypeToggle && $rideType() === 'None') {
    <div id="chooseYourSportOverlay" class="select-ride-type-overlay">
      <span class="triangle-top"></span>
      <div class="overlay-content">
        <h4 id="chooseYourSportTitle" class="helper-inline-block" i18n>Choose your sport</h4>
        <a
          id="chooseYourSportClose"
          class="helper-inline-block close"
          href="javascript:void(0);"
          (click)="closeRideTypeSelect()"
        >
          <svg-icon src="/assets/icons/close.svg" svgClass="close-icon" svgAriaLabel="close" i18n-svgAriaLabel />
        </a>
        <div id="chooseYourSportMessage" i18n>
          Select Off-Road or Snowmobiling to show all trails and ride areas related to your sport.
        </div>
      </div>
    </div>
  }

  <!--MAP SEARCH FLY-OUT-->
  @if ($isMobileView()) {
    <div class="map-search-fly-out">
      <a id="toggleSearch" href="javascript:void(0);" (click)="toggleSearch()">
        <svg-icon class="search-icon" src="/assets/icons/search.svg" svgAriaLabel="search" i18n-svgAriaLabel />
      </a>
    </div>
  }

  @if (isRadarVisible || isSnowDepthVisible) {
    <div class="legend-container">
      @if (isRadarVisible) {
        <div class="radar-container">
          <div>
            <div class="helper-bold" i18n>Rain</div>
            <img alt="Rain" ngSrc="/assets/images/map-legends/rain.png" i18n-alt />
            <div class="radar-amount">
              <div i18n>Light</div>
              <div i18n>Heavy</div>
            </div>
          </div>
          <div>
            <div class="helper-bold" i18n>Ice</div>
            <img alt="Ice" ngSrc="/assets/images/map-legends/ice.png" i18n-alt />
            <div class="radar-amount">
              <div i18n>Light</div>
              <div i18n>Heavy</div>
            </div>
          </div>
          <div>
            <div class="helper-bold" i18n>Snow</div>
            <img alt="Snow" ngSrc="/assets/images/map-legends/snow.png" i18n-alt />
            <div class="radar-amount">
              <div i18n>Light</div>
              <div i18n>Heavy</div>
            </div>
          </div>
        </div>
      }

      @if (isSnowDepthVisible) {
        <div class="snow-depth-container">
          <div class="helper-bold" i18n>Snow Depth (inches)</div>
          <img alt="Snow Depth" ngSrc="/assets/images/map-legends/snow-depth.png" i18n-alt />
          <div class="snow-depth-amount">
            <span i18n>0</span>
            <span i18n>1</span>
            <span i18n>2</span>
            <span i18n>4</span>
            <span i18n>10</span>
            <span i18n>20</span>
            <span i18n>40</span>
            <span i18n>60</span>
            <span i18n>100</span>
            <span i18n>200</span>
          </div>
        </div>
      }
    </div>
  }

  @if (enableRideCondition && isRideConditionVisible) {
    <div class="map-legend conditions-legend">
      <svg-icon
        src="/assets/icons/condition.svg"
        svgClass="condition good"
        svgAriaLabel="good condition"
        i18n-svgAriaLabel
      />
      <span class="label" i18n>Good</span>
      <svg-icon
        src="/assets/icons/condition.svg"
        svgClass="condition okay"
        svgAriaLabel="okay condition"
        i18n-svgAriaLabel
      />
      <span class="label" i18n>Okay</span>
      <svg-icon
        src="/assets/icons/condition.svg"
        svgClass="condition poor"
        svgAriaLabel="poor condition"
        i18n-svgAriaLabel
      />
      <span class="label" i18n>Poor</span>
    </div>
  }

  @if (enableMapControls) {
    <div class="map-controls" [ngClass]="{ 'use-mapbox-locator': hasBrowserLocationPermission }">
      @if (enableAddWaypoint) {
        <a id="waypointBtn" class="expandable-btn" href="javascript:void(0);" (click)="addWaypoint()">
          <svg-icon src="/assets/icons/saved-place.svg" svgAriaLabel="Add Place" i18n-svgAriaLabel />
          <span i18n>Add Place</span>
        </a>
      }
      @if (isHazardReportingEnabled) {
        <a
          id="trailConditionBtn"
          class="expandable-btn trail-condition-add"
          href="javascript:void(0);"
          (click)="createTrailCondition.emit()"
        >
          <svg-icon src="/assets/icons/alert-triangle.svg" svgAriaLabel="Add Place" i18n-svgAriaLabel />
          <span i18n>Add Hazard</span>
        </a>
      }
      <div class="map-control-combined">
        @if (hasLocationPermission$ | async) {
          <a
            class="combined-item vehicle-locator"
            href="javascript:void(0);"
            rdcAnalytics="Vehicle Locator"
            rdcAnalyticsData="Vehicle Locator Map"
            [ngClass]="{ selected: vehicleIsSelected }"
            (click)="vehicleLocate()"
          >
            @switch (vehicleType$ | async) {
              @case ('IND') {
                <svg-icon
                  src="/assets/icons/bike.svg"
                  svgAriaLabel="Locate Vehicle"
                  [svgClass]="`locate-indian-icon${vehicleIsSelected ? ' selected' : ''}`"
                  i18n-svgAriaLabel
                />
              }
              @case ('SLG') {
                <svg-icon
                  src="/assets/icons/slingshot.svg"
                  svgAriaLabel="Locate Vehicle"
                  [svgClass]="`locate-slingshot-icon${vehicleIsSelected ? ' selected' : ''}`"
                  i18n-svgAriaLabel
                />
              }
              @case ('ORV') {
                <svg-icon
                  src="/assets/icons/orv.svg"
                  svgAriaLabel="Locate Vehicle"
                  [svgClass]="`locate-orv-icon${vehicleIsSelected ? ' selected' : ''}`"
                  i18n-svgAriaLabel
                />
              }
              @case ('SNO') {
                <svg-icon
                  src="/assets/icons/snow.svg"
                  svgAriaLabel="Locate Vehicle"
                  [svgClass]="`locate-orv-icon${vehicleIsSelected ? ' selected' : ''}`"
                  i18n-svgAriaLabel
                />
              }
            }
          </a>
        }
        @if ((activeRideGroup$ | async)?.isCurrentRiderInGroup) {
          <a id="zoom-to-group" class="combined-item zoom-to-group" href="javascript:void(0);" (click)="zoomToGroup()">
            <svg-icon src="/assets/icons/group-ride-location.svg" alt="Locate Active Group Ride" i18n-alt />
          </a>
        }
        @if (!hasBrowserLocationPermission) {
          <a
            id="no-location-permission"
            class="combined-item no-location-permission"
            href="javascript:void(0)"
            (click)="showBrowserLocationPrompt()"
          >
            <svg-icon src="/assets/icons/bullseye.svg" alt="Locate Active Group Ride" i18n-alt />
          </a>
        }
      </div>
    </div>
  }
  @if (enableMapLegend) {
    <rdx-trail-legend-button />
  }

  <!--View on Map-->
  @if (enableLargerMapBtn) {
    <a id="viewOnMap" rdcAnalytics="View on Map" rdcAnalyticsData="Collection" [routerLink]="viewOnMapUrl">
      <button class="button secondary-button larger-map" type="button" i18n>Larger Map</button>
    </a>
  }
</div>

<rdx-map-debug
  [isDebug]="isDebug"
  [isLeft]="isLeft"
  [north]="north"
  [mouseLat]="mouseLat"
  [south]="south"
  [east]="east"
  [mouseLng]="mouseLng"
  [west]="west"
  [zoom]="zoom"
  [layers]="layers"
/>
